import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full m-auto fixed top-0 z-0" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/12" }, " ", -1)
const _hoisted_4 = { class: "w-9/12 m-auto" }
const _hoisted_5 = { class: "bg-white rounded-md mt-4" }
const _hoisted_6 = {
  key: 0,
  class: "text_center break-words"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "break-words underline"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "w-full bg-white rounded-md mt-4 mx-auto" }
const _hoisted_11 = { class: "w-full mt-4 mx-auto" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-left px-6 mb-2 font-bold text-opacity-60" }, "List of related graphs", -1)
const _hoisted_13 = { class: "px-6 py-2 w-full bg-white rounded-md text-left mb-8" }
const _hoisted_14 = { class: "w-2/12" }
const _hoisted_15 = { class: "sticky top-0" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 font-bold" }, [
  /*#__PURE__*/_createTextVNode("Get Started"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_18 = ["href"]
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Graph = _resolveComponent("Graph", true)!
  const _component_RelatedGraph = _resolveComponent("RelatedGraph")!
  const _component_x_icon = _resolveComponent("x_icon")!

  return (_ctx.graph_data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.isCopying)
          ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["flex", _ctx.isCopying ? 'opacity-30' : ''])
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.graph_data.title || _ctx.user_data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.graph_data.title || "A knowledge graph"), 1),
                    (_ctx.user_data)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                          _createTextVNode(" by "),
                          _createVNode(_component_router_link, {
                            to: _ctx.user_data.location_path()
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.user_data?.nickname), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.message_is_open ? '' : 'truncate', "break-words"]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.message_toggle && _ctx.message_toggle(...args)))
              }, _toDisplayString(_ctx.message), 3),
              (_ctx.graph_data.related_url)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("a", {
                      href: _ctx.graph_data.related_url
                    }, _toDisplayString(_ctx.graph_data.related_url), 9, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Graph, {
                class: "w-full mr-6 h-screen",
                graph_data: _ctx.graph_data.graph_data,
                onSelect_graph: _ctx.selectGraph
              }, null, 8, ["graph_data", "onSelect_graph"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_RelatedGraph)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (!_ctx.isSignedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                href: `https://twitter.com/intent/tweet?text=${_ctx.twitter_text}&url=${_ctx.url}&hashtags=instagraph`,
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                _createElementVNode("div", null, [
                  _createVNode(_component_x_icon, {
                    class: "w-10 mr-4 mt-2",
                    link: `https://twitter.com/intent/tweet?text=${_ctx.twitter_text}&url=${_ctx.url}`
                  }, null, 8, ["link"])
                ])
              ], 8, _hoisted_18),
              (_ctx.isSignedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.call_copy_graph && _ctx.call_copy_graph(...args))),
                      class: "border-2 p-1 rounded-md mt-4"
                    }, "Import Graph")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}